export default "__VITE_ASSET__aXXAzweK__"